import { Flex, Text, Icon } from '@chakra-ui/react';
import { DateTime } from 'luxon';
import React from 'react';

import { Util } from '@finley-technologies/finley-types';

import { RDFV } from 'packages/dataPipeline/types/dataPipelineTypes';
import { FiCalendar } from 'react-icons/fi';

function formatDateString(dateString: Util.FullDateStr): string {
  const date = DateTime.fromFormat(dateString, 'yyyy-M-d');
  return date.toFormat('MMMM d, yyyy');
}

export const DateAndVersionInput = ({
  selectedRDFV,
  onClick,
  children,
}: {
  selectedRDFV: RDFV | null;
  onClick: () => void;
  children?: React.ReactNode;
}) => {
  return (
    <Flex
      width="100%"
      borderWidth="1px"
      borderRadius="5px"
      padding="6px 16px"
      minHeight="40px"
      alignItems="center"
      cursor="pointer"
      onClick={onClick}
    >
      <Icon as={FiCalendar} marginRight="10px" h="inherit" />
      {selectedRDFV ? (
        <Text>
          {`${formatDateString(selectedRDFV.reportingDate)}, Version ${
            selectedRDFV.fileVersion
          }`}
        </Text>
      ) : (
        <Text>Select Date</Text>
      )}
      {children}
    </Flex>
  );
};
